<template>
  <k-page class="page-marathon-users">
    <the-marathon-users />
  </k-page>
</template>

<script>
/**
 * Component: page-marathon-users - Страница со списком участников системного старта
*
* @version 1.0.0
*/


// Components
import KPage from '@/components/KPage.vue';
import TheMarathonUsers from '@/components/TheMarathonUsers.vue';


export default {
  name: 'page-marathon-users',

  components: {
    KPage,
    TheMarathonUsers,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-marathon-users {
  $this: &;
}
</style>
